import React, { useState, useEffect, useContext, useMemo, useCallback} from "react";
import {Button} from "react-bootstrap";
import { NavigationContext } from "../../../context/navigation-context";
import useFetch from "../../../hooks/fetchMSSQL-hook";
import NoResults from "../../../components/NoResults/NoResults";
import moment from "moment";
import { LangContext } from "../../../context/lang-context";
import { BasicTable} from "../../../components/BasicTable"
import depositIcon from "../../../assets/images/deposit-icon.svg";
import SearchFilter from "../../../components/Filter/SearchFilter";
import KsefInvoiceModal from "../../../components/Modals/KsefInvoiceModal";

const Trxs = () => {
  const { TRL_Pack } = useContext(LangContext);
  const { fetchMssqlApi } = useFetch();
  const [showKsefInvoiceModal, setShowKsefInvoiceModal] = useState(false);
  const [ksefTrx, setKsefTrx] = useState({});
  const {setHeaderData } = useContext(NavigationContext);
  const [summaryInfo, setSummaryInfo] = useState({});
  const [trxs, setTrxs] = useState(null);
  const [refundList, setRefundList] = useState(() => {
    try {
      const saved = localStorage.getItem("refundList");
      return saved ? JSON.parse(saved) : [];
    } catch {
      return [];
    }
  });

  const reportList = [
    !["vep", "dev"].includes(sessionStorage.getItem("clientId")) && { reportId: 84, reportColor: "primary" },
    !["vep", "dev"].includes(sessionStorage.getItem("clientId")) && { reportId: 85, reportColor: "danger" },
    !["vep", "dev"].includes(sessionStorage.getItem("clientId")) && { reportId: 70, reportColor: "outline-secondary" },
    !["vep", "dev"].includes(sessionStorage.getItem("clientId")) && { reportId: 76, reportColor: "success" },
    !["vep", "dev"].includes(sessionStorage.getItem("clientId")) && { reportId: 77, reportColor: "outline-dark" },
    !["vep", "dev"].includes(sessionStorage.getItem("clientId")) && { reportId: 81, reportColor: "outline-success" },
    !["vep", "dev"].includes(sessionStorage.getItem("clientId")) && { reportId: 83, reportColor: "info" },
    !["vep", "dev"].includes(sessionStorage.getItem("clientId")) && { reportId: 89, reportColor: "secondary" },
    !["vep", "dev"].includes(sessionStorage.getItem("clientId")) && { reportId: 90, reportColor: "dark" },
    !["vep", "dev"].includes(sessionStorage.getItem("clientId")) && { reportId: 91, reportColor: "outline-info" },
    !["vep", "dev"].includes(sessionStorage.getItem("clientId")) && { reportId: 5, reportColor: "outline-primary" },
    !["vep", "dev"].includes(sessionStorage.getItem("clientId")) && { reportId: 6, reportColor: "outline-danger" },
    !["vep", "dev"].includes(sessionStorage.getItem("clientId")) && { reportId: 7, reportColor: "outline-success" },
    // { reportId: 82, reportColor: "outline-success"}, //Do wdrożenia jak już bedzie dobry raport
    ["vep", "dev"].includes(sessionStorage.getItem("clientId")) && { reportId: 5, reportColor: "outline-primary" },
    ["vep", "dev"].includes(sessionStorage.getItem("clientId")) && { reportId: 6, reportColor: "outline-danger" },
    ["vep", "dev"].includes(sessionStorage.getItem("clientId")) && { reportId: 7, reportColor: "outline-success" },
    ["vep", "dev"].includes(sessionStorage.getItem("clientId")) && { reportId: 15, reportColor: "primary" },
    ["vep", "dev"].includes(sessionStorage.getItem("clientId")) && { reportId: 24, reportColor: "danger" },
    ["vep", "dev"].includes(sessionStorage.getItem("clientId")) && { reportId: 46, reportColor: "success" },
    ["vep", "dev"].includes(sessionStorage.getItem("clientId")) && { reportId: 47, reportColor: "info" },
    ["vep", "dev"].includes(sessionStorage.getItem("clientId")) && { reportId: 48, reportColor: "secondary" },
    ["vep", "dev"].includes(sessionStorage.getItem("clientId")) && { reportId: 51, reportColor: "dark" },
    ["vep", "dev"].includes(sessionStorage.getItem("clientId")) && { reportId: 60, reportColor: "warning" },
    ["vep", "dev"].includes(sessionStorage.getItem("clientId")) && { reportId: 65, reportColor: 'light' },,
    ["vep", "dev"].includes(sessionStorage.getItem("clientId")) && { reportId: 66, reportColor: 'outline-primary' },
    ["vep", "dev"].includes(sessionStorage.getItem("clientId")) && { reportId: 69, reportColor: 'outline-danger' },
    ["vep", "dev"].includes(sessionStorage.getItem("clientId")) && { reportId: 70, reportColor: "primary" },
    ["vep", "dev"].includes(sessionStorage.getItem("clientId")) && { reportId: 71, reportColor: "outline-success" },
    ["vep", "dev"].includes(sessionStorage.getItem("clientId")) && { reportId: 72, reportColor: 'outline-info' },
    ["vep", "dev"].includes(sessionStorage.getItem("clientId")) && { reportId: 73, reportColor: 'outline-secondary' },
    ["vep", "dev"].includes(sessionStorage.getItem("clientId")) && { reportId: 74, reportColor: "outline-dark" },
    ["vep", "dev"].includes(sessionStorage.getItem("clientId")) && { reportId: 75, reportColor: "outline-warning" },
    ["vep", "dev"].includes(sessionStorage.getItem("clientId")) && { reportId: 76, reportColor: "primary" },
    ["vep", "dev"].includes(sessionStorage.getItem("clientId")) && { reportId: 77, reportColor: "outline-primary"},
    ["vep", "dev"].includes(sessionStorage.getItem("clientId")) && { reportId: 78, reportColor: "danger" },
    ["vep", "dev"].includes(sessionStorage.getItem("clientId")) && { reportId: 79, reportColor: "success" },
    ["vep", "dev"].includes(sessionStorage.getItem("clientId")) && { reportId: 81, reportColor: "outline-success" },
    ["vep", "dev"].includes(sessionStorage.getItem("clientId")) && { reportId: 83, reportColor: "info" },
    ["vep", "dev"].includes(sessionStorage.getItem("clientId")) && { reportId: 84, reportColor: "secondary" },
    ["vep", "dev"].includes(sessionStorage.getItem("clientId")) && { reportId: 85, reportColor: "dark" },
    ["vep", "dev"].includes(sessionStorage.getItem("clientId")) && { reportId: 86, reportColor: "warning" },
    ["vep", "dev"].includes(sessionStorage.getItem("clientId")) && { reportId: 87, reportColor: "light" },
    ["vep", "dev"].includes(sessionStorage.getItem("clientId")) && { reportId: 88, reportColor: "outline-primary" },
    ["vep", "dev"].includes(sessionStorage.getItem("clientId")) && { reportId: 89, reportColor: "outline-danger" },
    ["vep", "dev"].includes(sessionStorage.getItem("clientId")) && { reportId: 90, reportColor: "outline-success" },
    ["vep", "dev"].includes(sessionStorage.getItem("clientId")) && { reportId: 91, reportColor: "outline-info" },
    ["vep", "dev"].includes(sessionStorage.getItem("clientId")) && { reportId: 92, reportColor: "outline-secondary" },
    ["vep", "dev"].includes(sessionStorage.getItem("clientId")) && { reportId: 93, reportColor: "outline-dark" },
    ["bal", "dev"].includes(sessionStorage.getItem("clientId")) && { reportId: 97, reportColor: "outline-dark" },
    ["vep", "dev"].includes(sessionStorage.getItem("clientId")) && { reportId: 98, reportColor: "outline-warning" },
    ["vep", "dev"].includes(sessionStorage.getItem("clientId")) && { reportId: 99, reportColor: 'primary'},
    ["vep", "dev"].includes(sessionStorage.getItem("clientId")) && { reportId:100, reportColor: "danger" },
    ["vep", "dev"].includes(sessionStorage.getItem("clientId")) && { reportId:101, reportColor: "success" },
    ["vep", "dev"].includes(sessionStorage.getItem("clientId")) && { reportId:102, reportColor: 'info' },
    ["vep", "dev"].includes(sessionStorage.getItem("clientId")) && { reportId:103, reportColor: 'secondary' },
    ["bat", "max", "cav", "vep", "dev"].includes(sessionStorage.getItem("clientId")) && { reportId: 105, reportColor: "outline-primary" },
    ["bat", "max", "cav", "vep", "dev"].includes(sessionStorage.getItem("clientId")) && { reportId: 106, reportColor: "outline-danger" },
  ].filter(Boolean);

  const defaultFilter = {
    page: 1,
    sortBy: "none",
    dateTimeRangeFrom: moment().startOf("day").format("YYYY-MM-DDTHH:mm:ss"),
    dateTimeRangeTo: moment().endOf("day").format("YYYY-MM-DDTHH:mm:ss"),
    machineFeederNo: "",
    machineName: "",
    machineId: null,
    terminalId: null,
    serialNo: "",
    terminalTypeId: null,
    terminalTypeName: "",
    paymentTypeId: null,
    paymentTypeName: "",
    trxStatusTypeId: null,
    trxStatusTypeName: "",
    machineTags: { id: [], name: [] }
  }
  const [filter, setFilter] = useState(defaultFilter);
  const [settingsFilter, setSettingsFilter] = useState();
  const [defaultAdditionalFilter, setDefaultAdditionalFilter] = useState({terminal: '', machine: '', date: '', card: '', paymentType: '', productNo: '', price: '', nip: '', invoice: '', status: '', referralCode: ''});
  const [additionalFilter, setAdditionalFilter] = useState(defaultAdditionalFilter);

  const getSortState = () => {
    const [field, dir] = String(filter.sortBy || "").split("|");
    return { field, dir: (dir || "").toUpperCase() };
  };

  const arrow = (field) => {
    const [curField, curDirRaw] = String(filter.sortBy || "none").split("|");
    if (curField !== field) return "";
    return curDirRaw === "ASC" ? " ▲" : " ▼";
  };

  const handleHeaderSort = (field) => {
    const [curField, curDirRaw] = String(filter.sortBy || "none").split("|");
    const curDir = (curDirRaw || "").toUpperCase();
    let sortBy;
    let sortByName=""
    if (curField !== field) {sortBy = `${field}|DESC`;
    } else if (curDir === "DESC") {sortBy = `${field}|ASC`;
    } else if (curDir === "ASC") {sortBy = "none";
    } else sortBy = `${field}|DESC`;
    const next = { ...filter, sortBy, page: 1 };
    setFilter(next);
    search(next, settingsFilter.rowsPerPage, 1, true);
  };
  const trxStatusTypes = [{ TrxStatusTypeId: 1, Name: "Pozytywna" }, { TrxStatusTypeId: 2, Name: "Zwrot" }, { TrxStatusTypeId: 3, Name: "Odmowa" }];

  const handleStatusFilter = (statusId) => {
    const trxStatusTypeName = trxStatusTypes.find(x => x.TrxStatusTypeId === Number(statusId))?.Name;
    const next = { ...filter, trxStatusTypeId: statusId, trxStatusTypeName, page: 1};
    setFilter(next);
    search(next, settingsFilter.rowsPerPage, 1, true);
  };

  function formatNip(input) {
    if (input === null || input === undefined) return input;
    const original = String(input);
    const s = original.trim();
    if (!s) return original;
    const prefixMatch = s.match(/^([A-Za-z]{2})/);
    const prefix = prefixMatch ? prefixMatch[1].toUpperCase() : "";
    const digits = s.replace(/\D/g, "");
    if (digits.length !== 10) return original;  
    const formattedDigits = `${digits.slice(0, 3)}-${digits.slice(3, 6)}-${digits.slice(6, 8)}-${digits.slice(8, 10)}`;
    if (prefix) return `${prefix}${formattedDigits}`;
    return formattedDigits;
  }

  const refundIds = React.useMemo(
    () => new Set((refundList || []).map(x => x.TrxId)),
    [refundList]
  );

  const search = (f, pageSize, page, sort) => {
    let rowsPerPage = settingsFilter?.rowsPerPage ?? 100;
    if (pageSize != null) rowsPerPage = pageSize;
    const pageNo = Math.max(1, Number(page ?? f?.page) || 1);
    if (pageNo === 1) {
      getTrxsSummary(f);
    }
    getTrxs(f, rowsPerPage, pageNo);
  }

  const getTrxs = (f, rowsPerPage, pageNo) => {
    fetchMssqlApi(`trxs`, {method: "POST", hideNotification: true,
        data: {
          terminalSerialNo: f?.terminalSerialNo ? f.terminalSerialNo.split(" ").pop(): null,
          machineId: f?.machineId,
          terminalTypeId: f?.terminalTypeId,
          paymentTypeId: f?.paymentTypeId,
          statusTypeId: f?.trxStatusTypeId,
          fromCreateDateTime: f?.dateTimeRangeFrom,
          toCreateDateTime: f?.dateTimeRangeTo,
          machineFeederNo: f?.machineFeederNo,
          pageNo,
          rowsPerPage,
          machineTags: f?.machineTags?.id,
          sortBy: f?.sortBy,
        },
        showLoader: true,
      },
      (response) => setTrxs(response))
  };

  const getTrxsSummary = (f) => {
    fetchMssqlApi(`trxs/summary`, {method: "POST", hideNotification: true, showLoader: false,
        data: {
          terminalSerialNo: f?.terminalSerialNo ? f.terminalSerialNo.split(" ").pop(): null,
          machineId: f?.machineId,
          terminalTypeId: f?.terminalTypeId,
          paymentTypeId: f?.paymentTypeId,
          statusTypeId: f?.trxStatusTypeId ?? null,
          fromCreateDateTime: f?.dateTimeRangeFrom,
          toCreateDateTime: f?.dateTimeRangeTo,
          machineFeederNo: f?.machineFeederNo,
          machineTags: f?.machineTags.id,
        },
        showLoader: true,
      },
      (response) => setSummaryInfo(response))
  };

  const basicTableData = (trxs) => trxs?.map((i) => ([
    {key: "terminal", sortKey: "TerminalFullName",  name: "Terminal",     raw: i.TerminalFullName ?? "",  node: i.TerminalFullName ?? ""},
    {key: "machine",  sortKey: "MachineFullName",   name: "Automat",      raw: i.MachineFullName ?? "",   node: i.MachineFullName ?? ""},
    {key: "date",     sortKey: "CreateDateTime",    name: "Data / czas",  raw: i.CreateDateTime ?? "",    node: i.CreateDateTime ?? ""},
    {key: "paymentType", name: "Typ płatności", raw: i.PaymentType?.includes("Cash") ? "gotówka" : "bezgotówkowo", node: i.PaymentType?.includes("Cash") ? "Gotówka" : "Bezgotówkowo"},
    {key: "price", name: "Cena", raw: `${i.Price ?? ""} ${i.DepositPrice ?? ""}`, node: (<>
      {(() => {
        if (i.Status === "V_S" || i.Status === "A") return <span className="badge badge-success ml-1">{Intl.NumberFormat("pl-PL", { style: "currency", currency: "PLN" }).format(i.Price)}</span>;
        if (i.Status === "R_S") return <span className="badge badge-danger ml-1">{Intl.NumberFormat("pl-PL", { style: "currency", currency: "PLN" }).format(i.Price)}</span>;
        if (i.Status === "T_F") return <span className="badge badge-warning ml-1">{Intl.NumberFormat("pl-PL", { style: "currency", currency: "PLN" }).format(i.Price)}</span>;
        return null;
      })()}
      {i.DepositPrice && (
        <>
          <div className="ml-1 badge badge-info">{Intl.NumberFormat("pl-PL", { style: "currency", currency: "PLN" }).format(i.DepositPrice)}</div>
          <img className="ml-1" src={depositIcon} alt="Deposit icon" style={{ width: "24px" }}/>
        </>
      )}
    </>)},
    {key: "productNo", sortKey: "ProductNo", name: "Nr wyboru", raw: i.ProductNo ?? "", node: i.ProductNo ?? ""},
    {key: "status", name: "Status", raw: (() => {
        if (i.Status === "V_S" || i.Status === "A") return "pozytywna";
        if (i.Status === "R_S") return "zwrot";
        if (i.Status === "T_F") return "odmowa";
        return "";
      })(), node: (() => {
        if (i.Status === "V_S" || i.Status === "A") {return <span className="badge badge-success">Pozytywna</span>}
        if (i.Status === "R_S") {return <span className="badge badge-danger">Zwrot</span>}
        if (i.Status === "T_F") {return <span className="badge badge-warning">Odmowa</span>}
        return null;
      })(),
    },
    {key: "card",   sortKey: "CreditCardNo", name: "Nr karty", raw: i.CreditCardNo ?? "", node: i.CreditCardNo ?? ""},
    ...(["ret", "dev", "apd"].includes(sessionStorage.getItem("clientId")) ? [
      {key: "nip", name: "NIP", raw: i.Info?.NIP ?? "", node: i.Info?.NIP ? formatNip(i.Info.NIP) : ""},
      {key: "invoice", name: "Nr faktury", raw: i.Info?.InvoiceNumber ?? "", node: i.Info?.InvoiceNumber ?? ""},
    ] : []),
    ...(["vit"].includes(sessionStorage.getItem("clientId")) ? [
      {key: "referralCode", name: "Kod rabatowy", raw: i?.ReferralCode ?? "", node: i?.ReferralCode ?? ""},
    ] : []),
  ])) ?? [];

  const filtered = useMemo(() => {
    return trxs?.filter(item =>
      (additionalFilter.terminal === '' || `${item.TerminalFullName || ''}`.toLowerCase().includes(additionalFilter.terminal.toLowerCase())) &&
      (additionalFilter.machine === '' || `${item.MachineFullName || ''}`.toLowerCase().includes(additionalFilter.machine.toLowerCase())) &&
      (additionalFilter.date === '' || `${item.CreateDateTime || ''}`.toLowerCase().includes(additionalFilter.date.toLowerCase())) &&
      (additionalFilter.productNo === '' || `${item.ProductNo || ''}`.toLowerCase().includes(additionalFilter.productNo.toLowerCase())) &&
      (additionalFilter.card === '' || `${item.CreditCardNo || ''}`.toLowerCase().includes(additionalFilter.card.toLowerCase())) &&
      (additionalFilter.nip === '' || `${item.Info?.NIP || ''}`.toLowerCase().includes(additionalFilter.nip.toLowerCase())) &&
      (additionalFilter.invoice === '' || `${item.Info?.InvoiceNumber || ''}`.toLowerCase().includes(additionalFilter.invoice.toLowerCase())) &&
      (additionalFilter.referralCode === '' || `${item?.ReferralCode || ''}`.toLowerCase().includes(additionalFilter.referralCode.toLowerCase()))
    ) ?? [];
  }, [trxs, additionalFilter]);

  const toggleRefundSelected = useCallback((trx) => {
    setRefundList((prev) => {
      const next = prev.some((x) => x.TrxId === trx.TrxId)
        ? prev.filter((x) => x.TrxId !== trx.TrxId)
        : [...prev, trx];

      try {
        localStorage.setItem("refundList", JSON.stringify(next));
      } catch {}

      return next;
    });
  }, []);

  useEffect(() => {
    setHeaderData({ text: TRL_Pack.navigation.trxs });
  }, []);

  const handleSearchFilterChange = useCallback((f) => {
    setFilter(prev =>
      JSON.stringify(prev || {}) === JSON.stringify(f || {}) ? prev : f
    );
  }, []);

  return (
    <>
      <SearchFilter 
        filterName="trxs" 
        reportList={reportList}
        searchFilter={filter}
        defaultFilter={defaultFilter} 
        onFilterChange={handleSearchFilterChange}
        onSettingsChange={(s) => setSettingsFilter(s)}
        defaultAdditionalFilter={defaultAdditionalFilter}
        additionalFilter={additionalFilter}
        onAdditionalFilterChange={(af) => setAdditionalFilter(af)}
        search={search}
        totalCount={trxs?.length}
        additionalBarInfo={summaryInfo}
        refundList={refundList}
        setRefundList={setRefundList}
      />
      {trxs && (
            <div className="overflow-auto">
                <section className="card-body overflow-auto p-0 custom-scroll border" style={{ maxHeight: "calc(100vh - 150px)" }}>
                  {!settingsFilter?.flatView ? (
                    <table className="table table-striped">
                      <colgroup>
                        {sessionStorage.getItem("clientId") === "console" && (
                          <col style={{ minWidth: "80px"}}/>
                        )}
                        <col style={{ minWidth: "200px", maxWidth: "250px"}}/>
                        <col style={{ minWidth: "300px"}}/>
                        <col style={{ width: "200px" }} />
                        <col style={{ width: "220px" }} />
                        <col style={{ minWidth: "100px", width: "100px" }} />
                        <col style={{ minWidth: "250px", width: "300px" }} />
                        {["ret", "dev", "apd"].includes(sessionStorage.getItem("clientId")) && (
                          <>
                            <col style={{ minWidth: "100px", width: "150px" }} />
                            <col style={{ minWidth: "100px", width: "150px" }} />
                            <col style={{ minWidth: "100px", width: "100px" }} />
                          </>
                        )}
                        {["vit"].includes(sessionStorage.getItem("clientId")) && (
                          <>
                            <col style={{ minWidth: "140px", width: "140px" }} />
                          </>
                        )}
                      </colgroup>
                      <thead>
                        <tr className="headers-stick-trxs">
                          {sessionStorage.getItem("clientId") === "console" && (
                          <th className="p-2">
                            <div className="d-flex flex-flex text-nowrap">
                              Klient
                            </div>
                          </th>
                          )}
                          <th className="p-2">
                            <div className="d-flex flex-column align-items-center">
                              <div style={{ cursor: "pointer", userSelect: "none" }} onClick={() => handleHeaderSort("TerminalFullName")}>
                                Terminal{arrow("TerminalSort")}
                              </div>
                              {settingsFilter?.additionalFilter && (
                              <input type="text" value={additionalFilter.terminal}
                                onChange={e => {const value = e.target.value; setAdditionalFilter(prev => ({...prev, terminal: value}))}} 
                                className="form-control form-control-sm text-center"
                                style={{maxWidth: "120px", maxHeight: "20px",}}
                              />
                            )}
                            </div>
                          </th>
                          <th className="p-2">
                            <div className="d-flex flex-column align-items-center">
                              <div className="text-nowrap" style={{ cursor: "pointer", userSelect: "none" }} onClick={() => handleHeaderSort("MachineFullName")}>
                                Automat{arrow("MachineFullName")}
                              </div>
                              {settingsFilter?.additionalFilter && (
                              <input type="text" value={additionalFilter.machine}
                                onChange={e => {const value = e.target.value; setAdditionalFilter(prev => ({...prev, machine: value}))}} 
                                className="form-control form-control-sm text-center"
                                style={{maxWidth: "120px", maxHeight: "20px"}}
                              />
                              )}
                            </div>
                          </th>
                          <th className="p-2" >
                            <div className="d-flex flex-column align-items-center">
                              <div className="text-nowrap" style={{ cursor: "pointer", userSelect: "none" }}  onClick={() => handleHeaderSort("CreateDateTime")}>
                                Data / czas{arrow("CreateDateTime")}
                              </div>
                              {settingsFilter?.additionalFilter && (
                              <input type="text" value={additionalFilter.date}
                                onChange={e => {const value = e.target.value; setAdditionalFilter(prev => ({...prev, date: value}))}} 
                                className="form-control form-control-sm text-center"
                                style={{maxWidth: "120px", maxHeight: "20px"}}
                              />
                            )}
                            </div>
                          </th>
                          <th className="p-2">
                            <div className="d-flex flex-column align-items-center">
                              <div className="text-nowrap text-center mb-1">
                                Typ / Cena / Status
                              </div>
                              <div className="d-flex flex-row justify-content-center ml-3">
                                <div className="badge badge-success align-middle" onClick={() => handleStatusFilter(1)} style={{cursor: "pointer"}}>
                                  Pozytywna
                                </div>
                                <div className="badge badge-danger align-middle ml-1" onClick={() => handleStatusFilter(2)} style={{cursor: "pointer"}}>
                                  Zwrot
                                </div>
                                <div className="badge badge-warning align-middle ml-1" onClick={() => handleStatusFilter(3)} style={{cursor: "pointer"}}>
                                  Odmowa
                                </div>
                                <div className="badge badge-danger align-middle ml-1" onClick={() => handleStatusFilter(null)} style={{cursor: "pointer"}}>
                                  X
                                </div>
                              </div>
                            </div>
                          </th>
                          <th className="p-2">
                            <div className="d-flex flex-column align-items-center">
                              <div style={{ cursor: "pointer", userSelect: "none" }} onClick={() => handleHeaderSort("ProductNo")}>
                                Nr wyboru{arrow("ProductNo")}
                              </div>
                              {settingsFilter?.additionalFilter && (
                                <input type="text" value={additionalFilter.productNo}
                                  onChange={e => {const value = e.target.value; setAdditionalFilter(prev => ({...prev, productNo: value}))}} 
                                  className="form-control form-control-sm text-center"
                                  style={{maxWidth: "50px", maxHeight: "20px"}}
                                />
                              )}
                            </div>
                          </th>
                          <th className="p-2">
                            <div className="d-flex flex-column align-items-center">
                              <div style={{ cursor: "pointer", userSelect: "none" }} onClick={() => handleHeaderSort("CreditCardNo")}>
                                Nr karty{arrow("CreditCardNo")}
                              </div>
                              {settingsFilter?.additionalFilter && (
                                <input type="text" value={additionalFilter.card}
                                  onChange={e => {const value = e.target.value; setAdditionalFilter(prev => ({...prev, card: value}))}} 
                                  className="form-control form-control-sm text-center"
                                  style={{maxWidth: "120px", maxHeight: "20px"}}
                                />
                              )}
                            </div>
                          </th>
                          {["ret", "dev", "apd"].includes(sessionStorage.getItem("clientId")) && (<>
                            <th className="p-2">
                              <div className="d-flex flex-column align-items-center">
                                <div className="text-nowrap">NIP</div>
                                {settingsFilter?.additionalFilter && (
                                  <input type="text" value={additionalFilter.nip}
                                    onChange={e => {const value = e.target.value; setAdditionalFilter(prev => ({...prev, nip: value}))}} 
                                    className="form-control form-control-sm text-center"
                                    style={{maxWidth: "120px", maxHeight: "20px"}}
                                  />
                                )}
                              </div>
                            </th>
                            <th className="p-2">
                              <div className="d-flex flex-column align-items-center">
                                <div className="text-nowrap">Nr faktury</div>
                                {settingsFilter?.additionalFilter && (
                                  <input type="text" value={additionalFilter.invoice}
                                    onChange={e => {const value = e.target.value; setAdditionalFilter(prev => ({...prev, invoice: value}))}} 
                                    className="form-control form-control-sm text-center"
                                    style={{maxWidth: "120px", maxHeight: "20px"}}
                                  />
                                )}
                              </div>
                            </th>
                            <th className="p-2 text-center">
                              Zwrot środków
                            </th>
                          </>)}
                          {["vit"].includes(sessionStorage.getItem("clientId")) && (<>
                            <th className="p-2">
                              <div className="d-flex flex-column align-items-center">
                                <div className="text-nowrap">Kod rabatowy</div>
                                {settingsFilter?.additionalFilter && (
                                  <input type="text" value={additionalFilter.referralCode}
                                    onChange={e => {const value = e.target.value; setAdditionalFilter(prev => ({...prev, referralCode: value}))}} 
                                    className="form-control form-control-sm text-center"
                                    style={{maxWidth: "120px", maxHeight: "20px"}}
                                  />
                                )}
                              </div>
                            </th>
                          </>)}
                        </tr>
                      </thead>
                      <tbody>
                        {filtered?.length ? filtered.map((trx, idx) => (
                          <tr key={idx} >
                          {sessionStorage.getItem("clientId") === "console" && (
                          <td className="p-0 pl-1">
                            <div className="d-flex flex-row align-items-center">
                              {trx.CustomerName}
                            </div>
                          </td>
                          )}
                          <td className="p-0 pl-1">
                            <div className="d-flex flex-column align-items-center">
                                {trx.TerminalFullName}
                            </div>
                          </td>
                          <td className="p-0 pl-1">
                            <div className="d-flex flex-row">
                                {trx.MachineFullName}
                            </div>
                          </td>
                          <td className="p-0 pl-1">
                            <div className="d-flex flex-column align-items-center text-nowrap">
                                  {trx.CreateDateTime}
                            </div>
                          </td>
                          <td className="p-0 pl-1">
                            <div className="d-flex flex-row align-items-center h-100 text-nowrap">
                                {trx.PaymentType && trx.PaymentType.indexOf("Cash") !== -1 && (<i className="fas fa-coins fa-sm p-2" style={{fontSize: "27px"}}/>)}
                                {trx.PaymentType && trx.PaymentType.indexOf("Credit Card") !== -1 && trx.Price !== 0.0 && (<i className="fas fa-credit-card p-2" style={{fontSize: "27px"}}/>)}
                                {trx.PaymentType && trx.PaymentType.indexOf("Credit Card") !== -1 && trx.Price === 0.0 && (<i className="fas fa-creative-commons-zero p-2" style={{fontSize: "27px"}}/>)}
                                {trx.PaymentType && trx.PaymentType.indexOf("Prepaid Credit") !== -1 && (<i className="fas fa-credit-card fa-sm p-2" style={{fontSize: "27px"}}/>)}
                                {trx.PaymentType && trx.PaymentType.indexOf("Prepaid") !== -1 && (<i className="fas fa-credit-card fa-sm p-2" style={{fontSize: "27px"}}/>)}
                                {((trx.Status && trx.Status.indexOf("V_S") !== -1) || trx.Status.indexOf("A") !== -1) && (<>
                                <div className="badge badge-success">
                                  {Intl.NumberFormat("pl-PL", {style: "currency", currency: "PLN"}).format(trx.Price)}
                                </div>
                                {trx.DepositPrice && (
                                  <>
                                    <div className="ml-1 badge badge-info">
                                      {Intl.NumberFormat("pl-PL", {style: "currency", currency: "PLN"}).format(trx.DepositPrice)}
                                    </div>
                                    <img className="m-2" src={depositIcon} alt="Deposit icon" style={{ width: "38px"}}/>
                                  </>)}
                                </>)}
                                {trx.Status && trx.Status.indexOf("R_S") !== -1 && (
                                <div className="badge badge-danger">
                                  {Intl.NumberFormat("pl-PL", {style: "currency", currency: "PLN"}).format(trx.Price)}{" "}({trx.ProductNo})
                                </div>
                                )}
                                {trx.Status && trx.Status.indexOf("T_F") !== -1 && (
                                <div className="badge badge-warning ">
                                  {Intl.NumberFormat("pl-PL", {style: "currency", currency: "PLN"}).format(trx.Price)}{" "}({trx.ProductNo})
                                </div>
                                )}
                            </div>
                          </td>
                          <td className="p-0 pl-1">
                            <div className="d-flex flex-column align-items-center text-nowrap">
                              {trx.ProductNo}
                            </div>
                          </td>
                          <td className="p-0 pl-1">
                            <div className="align-items-start">
                              {trx.CreditCardNo}<br/>{trx.Info.Info && trx.Info.Info.toLowerCase().includes("kaucja") ? "" : trx.Info.Info}
                            </div>
                          </td>
                          {["ret", "dev", "apd"].includes(sessionStorage.getItem("clientId")) && (
                          <>
                          <td className="p-0 pl-1">
                            {trx.Info?.NIP && (
                            <div className="text-center align-middle">
                               {formatNip(trx.Info?.NIP)}
                            </div>
                            )}
                          </td>
                          <td className="text-center align-middle">
                            {trx.Info?.InvoiceNumber && (
                              <>
                                <Button variant="outline-primary" className="ml-1 py-1 px-2" onClick={() => {setShowKsefInvoiceModal(true); setKsefTrx(trx)}}>
                                  {trx.Info.InvoiceNumber}
                                </Button>
                                <KsefInvoiceModal show={showKsefInvoiceModal} onHide={() => setShowKsefInvoiceModal(false)} trx={ksefTrx}/>
                              </>
                            )}
                          </td>
                          <td className="p-0">
                            <div className="p-1 text-center text-primary">
                              <i style={{cursor: "pointer"}} className={refundIds.has(trx.TrxId) ? "fas fa-check-square" : "far fa-square"} onClick={() => toggleRefundSelected(trx)}/>
                            </div>
                          </td>
                          </>
                          )}
                          {["vit"].includes(sessionStorage.getItem("clientId")) && (
                          <>
                          <td className="p-0 pl-1">
                            <div className="text-center align-middle">
                              {trx.ReferralCode}
                            </div>
                          </td>
                          </>
                          )}
                        </tr>
                        )) : (
                          <tr>
                            <td
                              colSpan={(sessionStorage.getItem("clientId") === "console" ? 7 : 6) + (["ret", "dev", "apd"].includes(sessionStorage.getItem("clientId")) ? 3 : 0) + (["vit"].includes(sessionStorage.getItem("clientId")) ? 1 : 0)}
                              className="p-0"
                            >
                              <NoResults/>
                            </td>
                          </tr>
                        )}
                      </tbody>
                    </table>
                  ) : (
                    <BasicTable
                      data={basicTableData(trxs)}
                      additionalFilter={additionalFilter}
                      onAdditionalFilterChange={(af) => setAdditionalFilter(af)}
                      filter={filter}
                      onFilterChange={(f) => {search(f, settingsFilter.rowsPerPage, 1, true); setFilter(f)}}
                    />
                  )}
                </section>
            </div>
          )}
    </>
  );
};

export default Trxs;